import React, {useEffect, useState} from 'react';
import {useNavigate, useOutletContext} from "react-router-dom";
import {useInfiniteScroll} from "../../../hooks/useInfiniteScroll";
import {EmptyState} from "../../../components/common/EmptyStateProps";
import LoadMoreButton from "../../../components/common/LoadMoreButton";
import {setComma, splitDateTime} from "../../../utils/format";
import {OutletContextType} from "../../../types/common/oulet.comtext.types";
import {getMemberWithdrawalList} from "../../../api/transaction/withdrawalApi";


export default function WithdrawalListPage() {

    const navigate = useNavigate();
    const {searchTypes, setTotalSize, searchTrigger} = useOutletContext<OutletContextType>();
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);


    const {
        accumulatedRows,
        showMoreButton,
        nextPage,
        appendPageData,
        resetPageData,
    } = useInfiniteScroll();


    const handleSearch = async () => {
        try {
            setLoading(true);
            const response = await getMemberWithdrawalList({
                ...searchTypes,
                page: 1
            });
            if (response?.data?.data) {
                resetPageData(response.data.data, searchTypes.size | 5);
                setTotalSize(response.data.data.totalSize || 0);
            }
        } catch (err) {
            console.error('출금 내역 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleLoadMore = async () => {
        try {
            setLoadingMore(true);
            const response = await getMemberWithdrawalList({
                ...searchTypes,
                page: nextPage,
            });

            if (response?.data?.data) {
                appendPageData(response.data.data, searchTypes.size | 5);
            }
        } catch (err) {
            console.error('더보기 에러:', err);
        } finally {
            setLoadingMore(false);
        }
    };


    useEffect(() => {
        handleSearch();
    }, [searchTrigger]);


    if (loading) {
        return (
            <section className="bg-white no-gap">
                <div className="inner-box">
                    <p>데이터를 불러오는 중...</p>
                </div>
            </section>
        );
    }

    if (!accumulatedRows || accumulatedRows.length === 0) {
        return <EmptyState message="정산내역이 비어있습니다."/>;
    }

    return (
        <>
            <section className="bg-white no-gap">
                <div className="inner-box">
                    {accumulatedRows.map((item: any, index: number) => {

                        const isCompleted = item.status === "COMPLETED";
                        const status = item.status === "COMPLETED" ? "출금완료" : "출금실패";
                        const { date, time } = splitDateTime(item.regDate);

                        return (
                            <div
                                key={item.id || index}
                                className="payment-wrap"
                                onClick={() => navigate(`/settlement/withdrawal-list/${item.withdrawalCode}`)}
                                style={{cursor: "pointer"}}
                            >
                                <div className="payment-info">
                                    <div className="info-row">
                                        <div className="time">
                                            {date}
                                            <em className="line">{time}</em>
                                        </div>
                                        <div className={
                                            isCompleted
                                                ? "status finish"
                                                : "status cancel"
                                        }>{status}</div>
                                    </div>
                                    <div className="info-row">
                                        <div className="cont">출금</div>
                                        <div
                                            className={isCompleted ? "amount text-red" : "amount"}>-{setComma(item.withdrawalAmount)}원
                                        </div>
                                    </div>
                                    <div className="info-row">
                                        <div className="method">계좌이체</div>
                                    </div>
                                </div>
                            </div>
                    )}
                    )}
                </div>
            </section>

            <LoadMoreButton
                show={showMoreButton}
                loading={loadingMore}
                onClick={handleLoadMore}
            />

        </>
    )
}